import React, { Component } from 'react';
import { Fade, UncontrolledTooltip, Alert } from 'reactstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { string, number } from 'prop-types';
import Icon from '../Icon/Icon';
import { FMessage } from '../../hoc/IntlComponents';

class CopyContent extends Component {
  static propTypes = {
    content: string.isRequired,
    iconType: string.isRequired,
    copyMessageId: string.isRequired,
    tooltipMessageId: string.isRequired,
    tooltipTargetId: string.isRequired,
    delay: number,
  };

  state = {
    copied: false,
  };

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handleCopy = () => {
    this.setState(
      () => ({ copied: true }),
      () => {
        setTimeout(() => {
          this._mounted && this.setState(() => ({ copied: false }));
        }, 1200);
      },
    );
  };

  render() {
    const {
      content,
      copyMessageId,
      iconType,
      tooltipMessageId,
      tooltipTargetId,
      className,
      delay,
    } = this.props;
    const { copied } = this.state;
    return (
      <div className={className ? `copy-content ${className}` : 'copy-content'}>
        <CopyToClipboard text={content} onCopy={this.handleCopy}>
          <Icon type={iconType} onClick={this.handleClick} id={tooltipTargetId} />
        </CopyToClipboard>
        <UncontrolledTooltip placement="right" delay={delay ? delay : 250} target={tooltipTargetId}>
          <FMessage id={tooltipMessageId} />
        </UncontrolledTooltip>
        <Fade in={copied} className="copy-message">
          <Alert color="success">
            <FMessage id={`${copyMessageId}.copied`} />
          </Alert>
        </Fade>
      </div>
    );
  }
}

export default CopyContent;
